import React from "react";

// Séparateur « • » harmonisé sur tout le site :
// teinte beige/brun, bien visible et espacement constant.
export const Dot = () => (
  <span aria-hidden="true" className="mx-1.5 text-[#b07a63] font-medium">
    •
  </span>
);

// Rend une chaîne en remplaçant tout séparateur « • » ou « · »
// par un point beige/brun harmonisé.
export const DotText = ({ text }) => {
  const parts = String(text).split(/\s*[•·]\s*/);
  return (
    <>
      {parts.map((p, i) => (
        <React.Fragment key={i}>
          {i > 0 && <Dot />}
          {p}
        </React.Fragment>
      ))}
    </>
  );
};
